module.exports = __webpack_public_path__ + "img/7200.b0261e36.jpg";